import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    color: 'white',
    overflowY: 'auto',
  },
  logo: {
    margin: '5px 15px',
    maxHeight: '200px',
    objectFit: 'contain',
  },
  images: {
    maxHeight: '200px',
    objectFit: 'cover',
    boxShadow: '2px 4px 8px 0px black',
    display: 'block',
    width: '100%',
    height: 'auto',
  },
  nextbutton: {
    margin: '5px 15px',
    color: 'white',
    boxShadow: '1px 2px 4px 0px black',
    borderRadius: '1px',
  },
  standbyButton: {
    margin: '5px 15px',
    backgroundColor: theme.palette.background.light,
    color: 'white',
    borderRadius: '1px',
    boxShadow: '1px 2px 4px 0px black',
  },
  stopButton: {
    margin: '5px 15px',
    backgroundColor: theme.palette.danger.main,
    color: 'white',
    borderRadius: '1px',
    boxShadow: '1px 2px 4px 0px black',
  },
  startButton: {
    margin: '15px',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '1px',
    boxShadow: '1px 2px 4px 0px black',
  },
  paper: {
    position: 'absolute',
    width: 400,
    top: '50%',
    left: 'calc(50vw - 200px)',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  imgOverlay: {
    position: 'absolute',
    bottom: '0',
    background: theme.palette.background.seeThrough,
    width: '100%',
    padding: '8px',
  },
  clearButtonOverlay: {
    position: 'absolute',
    top: '0',
    backgroundColor: 'rgba(0,0,0,0)',
    width: '100%',
    padding: '8px',
  },
  imgContainer: {
    position: 'relative',
    margin: '0px 15px 15px 15px',
  },
  selectNextBox: {
    border: '4px dotted rgba(3,173,238,.2)',
    height: '200px',
    margin: '15px',
    backgroundColor: 'rgba(3,173,238,.2)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  channelStatus: {
    margin: '5px 15px',
    textAlign: 'center',
  },
  imgTitle: {
    margin: '15px 0px -1px 15px',
    width: '48px',
    backgroundColor: theme.palette.imageLabel.main,
    fontSize: '.70em',
    fontWeight: '600',
    textAlign: 'center',
    padding: '3px',
  },
  imgTitleQueue: {
    margin: '15px 0px -1px 15px',
    width: '58px',
    backgroundColor: theme.palette.imageLabel.dark,
    fontSize: '.70em',
    fontWeight: '600',
    textAlign: 'center',
    padding: '3px',
  },
  buttonText: {
    fontWeight: '600',
    fontSize: '1em',
    paddingLeft: '5px',
  },
}));

export default useStyles;
